import { DestroyRef, Directive, TemplateRef, ViewContainerRef, inject, input } from '@angular/core'
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop'
import { combineLatest } from 'rxjs'
import { ConnectionService } from '../services'
@Directive({
  selector: '[isOffline]',
})
export class IsOfflineDirective {
  private readonly destroyRef = inject(DestroyRef)

  private connectionService = inject(ConnectionService)
  private templateRef = inject(TemplateRef<unknown>)
  private viewContainer = inject(ViewContainerRef)

  readonly isOffline = input.required<boolean>()

  constructor() {
    combineLatest([toObservable(this.isOffline), this.connectionService.connection$])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(([show, isConnected]) => {
        this.viewContainer.clear()
        if (show !== isConnected) {
          this.viewContainer.createEmbeddedView(this.templateRef)
        }
      })
  }
}
